export default "__VITE_ASSET__CUJEHw$p__"